import {Component, OnInit, Input } from '@angular/core';
import { TextareaModel } from '../textarea.model';
import { AbstractWorkflowResultComponent } from '../../@core/abstract-workflow-result.component';

@Component({
    selector: 'abw-textarea-result',
    templateUrl: './textarea-result.component.html',
    styleUrls: ['./textarea-result.component.scss']
})
export class TextareaResultComponent extends AbstractWorkflowResultComponent<TextareaModel> {
    @Input() rows = 3;
}